var map = {
	"./2023_LTI_FeedBacks.png": "be26",
	"./2023_LTI_PollResult.png": "8806",
	"./ContrarianView.png": "a401",
	"./FullCover_Chi.jpg": "2640",
	"./FullCover_Chi2.jpg": "b4c9",
	"./FullCover_Chi3.jpg": "aec8",
	"./FullCover_Chi4.jpg": "3282",
	"./FullCover_Eng.jpg": "c48a",
	"./FullCover_Eng2.jpg": "7357",
	"./FullCover_Eng3.jpg": "f218",
	"./FullCover_Eng4.jpg": "7857",
	"./FullCover_Eng5.jpg": "3d6e",
	"./about_YinLoo.png": "33ec",
	"./about_ali.png": "4a18",
	"./about_elaine.png": "b455",
	"./about_elaine2.png": "f271",
	"./about_elaine_cover.jpg": "f949",
	"./about_elaine_header.jpg": "31ed",
	"./about_elaine_old.png": "a237",
	"./about_office_10.jpg": "544c",
	"./about_office_2.jpg": "c098",
	"./about_office_3.jpg": "fa50",
	"./about_tom.png": "a41b",
	"./aiwriter_generator1.jpg": "b087",
	"./aiwriter_generator2.jpg": "d5c8",
	"./android.svg": "f277",
	"./assignment.svg": "5334",
	"./background/contactus.jpg": "91cd",
	"./background/contactus.jpg~": "a6d8",
	"./background/subheader01.jpg": "0275",
	"./background/subheader01.jpg~": "9508",
	"./background/subheader01_bottom.jpg": "0851",
	"./background/subheader01_bottom.jpg~": "6f1e",
	"./background/subheader01_mid.jpg": "81d0",
	"./background/subheader01_mid.jpg~": "2d17",
	"./background/subheader01_top.jpg": "1348",
	"./background/subheader01_top.jpg~": "07a8",
	"./background/subheader02.jpg": "a0c5",
	"./background/subheader02_mid.jpg": "a6b0",
	"./background/subheader02_mid.jpg~": "2d9b",
	"./background/subheader03_top.jpg": "1b20",
	"./background/testimonial.jpg": "922f",
	"./background/testimonial.jpg~": "c6c8",
	"./close.svg": "1d1b",
	"./cloud-solid.svg": "284a",
	"./comp_benchmark.jpg": "2000",
	"./compensation.jpg": "f9e9",
	"./compensation_benchmarking_banner.jpg": "e7d6",
	"./compensation_benchmarking_chart.jpg": "89a9",
	"./consultant/appraisal.svg": "9404",
	"./consultant/compbenchmark.svg": "7ce1",
	"./consultant/consultant01.jpg": "b3f4",
	"./consultant/consultant01.jpg~": "f4e3",
	"./consultant/consultant02.jpg": "cf56",
	"./consultant/consultant03.jpg": "1494",
	"./consultant/consultantbg01.jpg": "48b9",
	"./consultant/consultantbg02.jpg": "0583",
	"./consultant/directors.svg": "b45b",
	"./consultant/executive.svg": "db1b",
	"./consultant/incentive.svg": "c659",
	"./consultant/integration.svg": "1946",
	"./consultant/marketresearch.svg": "26a0",
	"./consultant/orgdesign.svg": "84b8",
	"./consultant/relocation.svg": "19ab",
	"./consultant/stock.svg": "becc",
	"./consultant/talentmanage.svg": "1b2f",
	"./consulting.jpg": "e1bf",
	"./cyber-security.jpg": "94a8",
	"./directors_remuneration_banner.jpg": "d2ce",
	"./ebi_banner.jpg": "6bf8",
	"./elu.jpg": "c42b",
	"./envelope.svg": "d870",
	"./erp_analytics.jpg": "c944",
	"./erp_stimulate.jpg": "ffd0",
	"./exec_comp_banner.jpg": "e023",
	"./gallery.jpg": "1897",
	"./getty.jpg": "acca",
	"./hiring.jpg": "eefc",
	"./home banner_top.jpg": "fa42",
	"./home_ai_banner.png": "fcee",
	"./home_banner.jpg": "b0d4",
	"./home_banner_coins.jpg": "04ee",
	"./home_money_plant.jpg": "a887",
	"./id-card-solid.svg": "c3b9",
	"./join.jpg": "17d1",
	"./laptop_charts.jpg": "3840",
	"./ma_banner.jpg": "f51e",
	"./market_insight.png": "cce6",
	"./market_insight_privacy.jpg": "365b",
	"./market_research_banner.jpg": "b3f9",
	"./marketinsights_banner.jpg": "ce98",
	"./online/ai_hr_writer.svg": "e942",
	"./online/aims.svg": "69bd",
	"./online/aiva.png": "c01d",
	"./online/benefit.svg": "188d",
	"./online/benefit2.svg": "9563",
	"./online/ec_private.svg": "59260",
	"./online/ec_private2.svg": "4f51",
	"./online/ec_public.svg": "fb4e",
	"./online/ec_public2.svg": "ef84",
	"./online/jes.svg": "fc2d",
	"./online/marketinsight.svg": "9779",
	"./online/mi_survey.svg": "6ea8",
	"./online/online01.jpg": "6976",
	"./online/online02.jpg": "863f",
	"./online/pas.svg": "9852",
	"./online/risk.svg": "1bc4",
	"./online/salary_range.svg": "3a83",
	"./online/seminar.svg": "8de0",
	"./online/sip.svg": "18b6",
	"./online/supercomp.svg": "0c75",
	"./online/svgrepo.txt": "9f4d",
	"./operating_model.png": "5277",
	"./org_design_banner.jpg": "d8de",
	"./pay_trend.jpg": "b0bc",
	"./people.svg": "6b3b",
	"./performance_appraisal_banner.jpg": "d7c2",
	"./performance_appraisal_banner2.jpg": "daf1",
	"./predictive1.jpg": "fcf0",
	"./predictive_banner.jpg": "d4bc",
	"./predictive_dashboard1.png": "1c77",
	"./predictive_dashboard2.png": "e557",
	"./predictive_header.jpg": "0658",
	"./presentation.svg": "5922",
	"./relocation_banner.jpg": "9eb9",
	"./retail_forum.png": "93ab",
	"./sales_incentive_plan_banner.jpg": "7c1b",
	"./sales_people.jpg": "9597",
	"./scale.svg": "2907",
	"./seminar_banner.jpg": "4975",
	"./seminar_member_macbook.jpg": "0448",
	"./seminar_seminar.jpg": "a429",
	"./seminar_seminar_body.jpg": "308e",
	"./seminar_seminar_header.jpg": "94e6",
	"./seminar_symposium.jpg": "ae21",
	"./seminar_symposium_body.jpg": "71562",
	"./social_responsibility_MRC-collage.jpg": "62fa",
	"./social_responsibility_book.jpg": "1529",
	"./social_responsibility_book_header.jpg": "d952",
	"./social_responsibility_book_pic1.jpg": "b428",
	"./social_responsibility_book_run.jpg": "7f84",
	"./social_responsibility_book_shop.jpg": "0aae",
	"./social_responsibility_book_shop2.jpg": "aa4d",
	"./social_responsibility_cheque.jpg": "82af",
	"./social_responsibility_iamuntaught_book.jpg": "93de",
	"./stock_plan_banner.jpg": "ab23",
	"./talent_management_banner.jpg": "ed50",
	"./testimonial-bg.jpg": "3b41",
	"./th.svg": "fdca",
	"./tools_Benefit_Data_Services.jpg": "88e0",
	"./tools_Board_of_Directors_Remuneration.jpg": "688c",
	"./tools_Executive_Compensation_Survey.jpg": "5c53",
	"./tools_Expatriate_Practice_Report.jpg": "b4e8",
	"./tools_HRmarkets.png": "3891",
	"./tools_Industry_club_group_customised_survey.jpg": "b1e9",
	"./tools_Sales_Incentive_Market_Practices_Report.jpg": "eec0",
	"./tools_banner.jpg": "b168",
	"./tools_bg1.jpg": "71af",
	"./tools_bg2.jpg": "7434",
	"./tools_economy.png": "629a",
	"./tools_economy_banner.jpg": "75ff",
	"./tools_forecast_banner.jpg": "1b38",
	"./tools_forecast_predictor.png": "57c0",
	"./tools_hr_banner.jpg": "0a8e",
	"./tools_legislation1.png": "df38",
	"./tools_legislation2.jpg": "c0df",
	"./tools_legislation3.png": "2bfd",
	"./tools_news.png": "0c3f",
	"./tools_news_banner.jpg": "0c96",
	"./tools_paytrend1.jpg": "62b8",
	"./tools_paytrend1_1.png": "47bb",
	"./tools_paytrend2.png": "c7e3",
	"./tools_paytrend_livingwage.png": "3354",
	"./tools_paytrend_minwage.png": "024c",
	"./tools_pic1.jpg": "cf53",
	"./tools_productivity_financial.png": "d09d",
	"./tools_productivity_financial_banner.jpg": "8695",
	"./tools_relocation_banner.jpg": "c5c1",
	"./tools_relocation_calculator1.png": "4d24",
	"./tools_relocation_calculator2.png": "d961",
	"./tools_super_compensation.jpg": "b5ab",
	"./tools_super_compensation2.jpg": "dd5b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";